<template>
<div>

<div class="modal-content border border-success">
<div  style="background-color:#9acd32;color:black" class="modal-header border border-success text-nowrap ">
  <h4 class="modal-title ">
    <i style="color:blue" class="fas fa-cash-register mr-3" aria-hidden="true"></i>     
    <strong>STAMPA SCONTRINO FISCALE</strong>
  </h4>  
</div>

<div class="modal-body border border-success">
  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
</div>

<div class="modal-footer">
    <button @click="$emit('close')" type="button" class="btn btn-secondary ">
      <i class="fas fa-reply mr-2" aria-hidden="true"></i>
        ANNULLA
    </button>

    <button  @click="postXML()" :disabled="bt_spinner==true" type="button" class="btn btn-primary ">
          <i class="fas fa-print mr-2" aria-hidden="true"></i>   
            STAMPA 
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button>    
</div>

</div>

</div>

</template>

<script>

//import api            from '@/api'
import axios          from 'axios'
import alertBox       from '@/components/common/AlertBox.vue'
import fmt            from '@/components/mixins/fmt'
import getSaleData    from '@/components/rt/mixins/getSaleData'
import { mapGetters }    from 'vuex'

  export default {
  props : ['data'],
  mixins : [fmt,getSaleData],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
          items    : [],
          payments : [],
          bt_spinner : false
                          
      }
    },

      computed: {
     ...mapGetters(['company']),
      
    },
    async created()
    {
      console.log('RCH',this.data)
      const data     = await this.getSaleData(this.data.saleId)
      this.items     = data[0]
      this.payments  = data[1]
      
    }, 
    methods: 
    {
    
    /*
     checkStatus()
     {
        let xml = '<Service><cmd>=K</cmd></Service>'
     },
     */
     getXML()
     {  
        
        const lotteryID = this.data.lottery ? "<cmd>=/?L/$1/" + this.data.lottery + "</cmd>"  : ''
        //let xml = '<?xml version="1.0" encoding="UTF-8"?>'
        let xml  = '<Service>'
        xml      += lotteryID
    
        this.items.forEach(item =>
        {
          
          const price = this.fmt1(item.price).replace('.',"").replace(',','')          
          xml += '<cmd>=R1/$'+ price + '/ (' + item.barcode + ' ' + item.category + ')</cmd>'    
          if(item.discount > 0)
          {
            const discount_value = this.fmt1(item.discount_value).replace('.',"").replace(',','')
            xml += '<cmd>=V/$' + discount_value + '</cmd>'      
          }
        }) 


        let discount = this.items[0].total_discount
        let coupon   = 0
        this.payments.forEach(item=>{

          if(item.typeId == 'COUP')
          { 
            coupon = item.amount            
          }          
        })
        let total_discount = discount + coupon

        if(total_discount > 0)
        {
          const total = this.fmt1(total_discount).replace('.',"").replace(',','')
          xml += '<cmd>=S</cmd>'    
          xml += '<cmd>=V/$' + total + '</cmd>'    
          
        }  


        this.payments.forEach(item=>{

          if(item.typeId == 'CASH')
          { 
            const cash = this.fmt1(item.amount).replace('.',"").replace(',','')
            xml += '<cmd>=T1/$' + cash + '</cmd>'    
          }   
          
            
          if(item.typeId == 'ELEC')
          { 
            const elec = this.fmt1(item.amount).replace('.',"").replace(',','') 
            /* PRIMIZIE */
            const tender = this.company.Id == 18 ? 'T3' : 'T4'
            xml += '<cmd>='+ tender + '/$' + elec + '</cmd>'    
          }
    
          if(item.typeId == 'CRED')
          { 
            const notPaid = this.fmt1(item.amount).replace('.',"").replace(',','') 
            xml += '<cmd>=T2/$' + notPaid + '</cmd>'    
          }
    
        })

        /* CODE 39 */
        xml += '<cmd>="/$4/ (' + "S" + this.data.saleId + ') </cmd>' 
        
        xml += '<cmd>=c</cmd>'
        xml += '</Service>'
       
        console.log('RCH XML ',xml)
        return xml

     },
 
     postXML() 
     {    
          this.bt_spinner = true
          //const xml = this.getXML()
          const xml = this.getXML()
          axios({
               
                url     : this.data.url + '/service.cgi',
                method  : 'post',
                data    : xml,
                headers : {'Content-Type': 'application/xml'}
                
                

              }).then(res => {      
                
                console.log('RCH FISCAL RESPONSE NEW ',res)
                this.$emit('close')
                

              }).catch(err => {

                this.bt_spinner = false
                console.log('RCH error',err)  
              })
        
        
        
   
     } 
      

    }
  }
</script>
<style scoped>
.modal-footer {  
  justify-content: space-between;  
}
 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.modal-content
{
  width:  500px;
}
</style>
